import React, { useState} from "react";
import ProfileContainer from "./components/ProfileContainer";
import QuoteContainer from "./components/QuoteContainer";
import NewsContainer from "./components/NewsContainer";
// import Header from "./components/Header";
// import Footer from "./components/Footer";
import {
  // BrowserRouter as Router,
  HashRouter,
  Switch,
  Route,
  Link
} from "react-router-dom";
import Socials from "./components/Socials";
import Boards from "./components/Boards";
import Chart from "./components/Chart";
import Market from "./components/Market";
import SocialMedia from "./components/SocialMedia";
import Coins from "./components/coinpot/Coins";
import MarketCoin from "./components/coinpot/MarketCoin";


function Home({
  profile,
  trade_data,
  short_interest,
  quote,
  news,
  disclosure,
  search
}) {
  return (
    <>
      <div className="bg-light">
        <div>
          <ProfileContainer profile={profile} />
        </div>
        <hr className="bg-light my-1 my-sm-3"></hr>
        <div className="py-2">
          <Chart stock={search} />
        </div>
        <hr className="bg-light my-1 my-sm-3"></hr>
        <div>
          <QuoteContainer
            trade_data={trade_data}
            short_interest={short_interest}
            quote={quote}
            disclosure={disclosure}
            profile={profile}
          />
        </div>
        <hr className="bg-light my-1 my-sm-3"></hr>
        <div>
          <NewsContainer news={news} search={search} />
        </div>
        <hr className="bg-light my-1 my-sm-3"></hr>
      </div>
    </>
  );
}



function SearchStocks({socialsSearch,searchSubmit,setSearch,messageBoardSearch,toInputUppercase}){
  return (
        <div className=" mx-auto bg-dark text-white">
        <form className="p-4 p-sm-5 row" onSubmit={e => searchSubmit(e)}>
          <div className="col-xs-3">
            <label htmlFor="search" className="col-xs-3">
              Enter Company Ticker Symbol here
            </label>
            <input
              type="text"
              name="search"
              onInput={toInputUppercase} // Capitalizes Input
              className="form-control mt-1"
              placeholder="Search Quote"
              onChange={e => setSearch(e.target.value)}
            ></input>
            <button type="submit" className="btn px-3 btn-primary mt-1 text-white">
              Submit
            </button>
            <button className="btn mx-2 btn-outline-primary px-3 mt-1">
              <Link to="/market">Market Activity</Link>
            </button>
          </div>
        </form>

        <div className="d-flex text-center p-4" style={{ fontSize: 14 }}>
          <Link to="/" className="p-3 bg-secondary text-light m-1">
            Quotes
          </Link>
          <Link
            to="/socials"
            className="p-3 bg-secondary text-light m-1"
            onClick={() => socialsSearch()}
          >
            Social Media
          </Link>
          <Link
            to="/boards"
            className="p-3  bg-secondary text-light m-1"
            onClick={messageBoardSearch}
          >
            Message Boards
          </Link>
        </div>
      </div>
  )

}


function SearchCoins({setSearch,socialsSearch,toInputUppercase,searchSubmit}){
  return (
        <div className="mx-auto bg-light text-dark px-4">
        <button className="btn px-3 mt-4" style={{borderColor:'#384AD3'}}>
          <Link to="/coins-market" style={{color:'#384AD3'}}>Market Activity</Link>
        </button>
        <form className="py-3 px-3 py-sm-3 px-sm-3 row" onSubmit={e => searchSubmit(e)}>
          <div className="col-xs-3">
            <label htmlFor="search" className="col-xs-3">
              Enter Crypto Currency Symbol Here
            </label>
            <input
              type="text"
              name="search"
              onInput={toInputUppercase} // Capitalizes Input
              className="form-control mt-1"
              placeholder="Search Symbol"
              onChange={e => setSearch(e.target.value)}
            ></input>
            <button type="submit" className="btn text-white px-3 mt-1" style={{backgroundColor:'#384AD3'}}>
              Submit
            </button>
          </div>
        </form>

      <div className="d-flex text-center" style={{ fontSize: 14 ,backgroundColor:'#384AD3'}}>
        <Link to="/coins" className="p-3 text-light  rounded" style={{backgroundColor:'#384AD3'}}>
          Quotes
        </Link>
        <Link
          // onClick={() => socialsSearch(" token")}
          to="/coins-socials"
          className="p-3 text-light rounded"
          style={{backgroundColor:'#384AD3'}}
        >
          Social Media
        </Link>
        {/* <Link
          to="/coins-boards"
          className="p-3  bg-secondary text-light m-1"
        >
          Message Boards
        </Link> */}
      </div>

      </div>
  )

}


function LoadingModal() {
  return (
    <div  style={{backgroundColor:'rgba(255,255,255, 0.7)'}} className="py-5 opacity-100 position-absolute vh-100 vw-100  d-flex justify-content-center" id="myModal">
      <div className="d-flex align-align-items-center pt-5 mt-5">
        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
        <p className="ml-2 font-weight-bold">Loading...</p>
      </div>
    </div>
  )
}




function App() {
  const [search, setSearch] = useState("");
  const [profile, setProfile] = useState("");
  const [quote, setQuote] = useState("");
  const [news, setNews] = useState("");
  const [short_interest, setShortInterest] = useState("");
  const [trade_data, setTradeData] = useState("");
  const [disclosure, setDisclosure] = useState("");
  const [loading,setLoading] = useState(false);

  // SOCIALS
  const [youtube, setYoutube] = useState("");
  // const [reddit, setReddit] = useState("");
  const [fb, setFb] = useState("");
  const [tweet, setTweet] = useState("");


  // MESSAGE BOARDS
  const [ihub, setIhub] = useState("");
  const [fools, setFools] = useState("");
  const [stocktwits, setStockTwits] = useState({});
  const [thelion, setTheLion] = useState([]);



  // COINPOT
  const [nomics, setNomics] = useState("");
  const [coinMetadata, setCoinMetadata] = useState("");

  const toInputUppercase = e => {
    e.target.value = ("" + e.target.value).toUpperCase();
  };

  const searchSubmit = e => {
    if(!window.location.href.includes('coin')){
      window.location.href="/#/"
    }
    setLoading(true);
    e.preventDefault();

    socialsSearch()
    messageBoardSearch()
    coinSearch()

    // setSearch("");
    setProfile("");
    // setFilings("");
    setNews("");
    setShortInterest("");
    setQuote("");
    setTradeData("");
    setDisclosure("");
    setYoutube("");
    setFb("");
    setTweet("")
    setNomics("")
    setCoinMetadata("")


    if (search !== "") {
      // PROFILE
      fetch(`https://stoxxboxx.herokuapp.com/profile/${search}`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setProfile(data);
          setLoading(false);
        })
        .catch(error => {
          console.log("Empty Data");
        });

      // FILINGS
      //       fetch(`https://stoxxboxx.herokuapp.com/filings/${search}`)
      //         .then(res => res.json())
      //         .then(data => {
      //           console.log(data);
      //           setFilings(data);
      //         })
      //         .catch(error => {
      //           console.log("Empty Data");
      //         });

      // NEWS
      fetch(`https://stoxxboxx.herokuapp.com/news/${search}`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setNews(data);
        })
        .catch(error => {
          console.log("Empty Data News",error);
        });

      // SHORT INTEREST
      fetch(`https://stoxxboxx.herokuapp.com/short_interest/${search}`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setShortInterest(data);
        })
        .catch(error => {
          console.log("Empty Data");
        });

      // TRADE DATA
      fetch(`https://stoxxboxx.herokuapp.com/trade_data/${search}`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setTradeData(data);
        })
        .catch(error => {
          console.log("Empty Data");
        });

      // Quote Data
      fetch(`https://stoxxboxx.herokuapp.com/quote/${search}`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setQuote(data);
        })
        .catch(error => {
          console.log("Empty Data");
        });

      // Disclosure Data
      fetch(`https://stoxxboxx.herokuapp.com/disclosure/${search}`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          setDisclosure(data);
        })
        .catch(error => {
          console.log("Empty Data");
        });



    }
  };

  const socialsSearch = (additional_words="") => {
    if(window.location.hash==="#/coins-socials" || window.location.hash==="#/coins"){
      additional_words = " token"
    }
    // YOUTUBE
    fetch(`https://stoxxboxx.herokuapp.com/youtube/$ ${search+additional_words}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setYoutube(data);
      })
      .catch(error => {
        console.log("Empty Youtube Data");
      });

    // REDDIT
    // fetch(`https://stoxxboxx.herokuapp.com/reddit/${search+additional_words}`)
    //   .then(res => res.json())
    //   .then(data => {
    //     console.log(data);
    //     setReddit(data);
    //   })
    //   .catch(error => {
    //     console.log("Empty Data");
    //   });

    // TWITTER SEARCH
    fetch(`https://stoxxbox-socials.herokuapp.com/tweets/$ ${search+additional_words}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setTweet(data);
      })
      .catch(error => {
        console.log("Empty Twitter Data");
      });

    // FACEBOOK SEARCH
    fetch(`https://stoxxbox-socials.herokuapp.com/fb/$ ${search+additional_words}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setFb(data.results);
      })
      .catch(error => {
        console.log("Empty Facebook Data");
      });

  };

  const messageBoardSearch = () => {
    // IHUB
    fetch(`https://stoxxboxx.herokuapp.com/ihub/${search}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setIhub(data);
      })
      .catch(error => {
        console.log("Empty Data");
      });

    // FOOL
    fetch(`https://stoxxboxx.herokuapp.com/fools/${search}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setFools(data);
      })
      .catch(error => {
        console.log("Empty Data");
      });

    // Stocktwits
    fetch(`https://stoxxboxx.herokuapp.com/stocktwits/${search}`)
      .then(res => res.json())
      .then(data => {
        setStockTwits(data);
        console.log("STOCK TWITS",stocktwits);
      })
      .catch(error => {
        console.log("Empty Data");
      });

    // TheLion
    fetch(`https://stoxxboxx.herokuapp.com/thelion/${search}`)
      .then(res => res.json())
      .then(data => {
        setTheLion(data);
        console.log("THE LION",thelion);
      })
      .catch(error => {
        console.log("Empty Data");
      });

  };


  const coinSearch = () => {
    // COIN
    fetch(`https://stoxxboxx.herokuapp.com/nomics/${search}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setNomics(data);
      })
      .catch(error => {
        console.log("COIN",error);
      });

    // COIN METADATA
    fetch(`https://stoxxboxx.herokuapp.com/coin-metadata/${search}`)
      .then(res => res.json())
      .then(data => {
        console.log(data);
        setCoinMetadata(data);
      })
      .catch(error => {
        console.log("COIN_METADATA",error);
      });
  };


  return (
    <HashRouter>
      {loading?<LoadingModal/>:""}{/* Spinner Loader */}
      <Switch>
        <Route exact path="/">
          <SearchStocks setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <Home
            quote={quote}
            trade_data={trade_data}
            short_interest={short_interest}
            profile={profile}
            news={news}
            disclosure={disclosure}
            search={search}
          />
        </Route>
        <Route path="/socials">
          <>
            <SearchStocks setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
            <Socials youtube={youtube} />
            <SocialMedia tweet={tweet} fb={fb} />
          </>
        </Route>
        <Route path="/market">
          <SearchStocks setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <Market />
        </Route>
        <Route path="/boards">
          <SearchStocks setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <Boards ihub={ihub} fools={fools} stocktwits={stocktwits} thelion={thelion}/>
        </Route>
        <Route path="/coins/">
          <SearchCoins setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <Coins coin={nomics} coin_metadata={coinMetadata}/>
        </Route>
        <Route path="/coins-socials/">
          <SearchCoins setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <Socials youtube={youtube} />
          <SocialMedia tweet={tweet} fb={fb} />
        </Route>
        {/* <Route path="/coins-boards">
          <SearchCoins setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
        </Route> */}
        <Route path="/coins-market/">
          <SearchCoins setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <MarketCoin/>
        </Route>
        <Route path="/*">
          <SearchStocks setSearch={setSearch} socialsSearch={socialsSearch} messageBoardSearch={messageBoardSearch} searchSubmit={searchSubmit} toInputUppercase={toInputUppercase}/>
          <Home quote trade_data short_interest profile news />
        </Route>
      </Switch>

      {/* <Footer /> */}
    </HashRouter>
  );
}

export default App;
